// @ts-ignore
import { useSelector } from 'react-redux';
import { isInitialLoadDone, getInitialLoadProgress } from '../selectors/entries';

export const initialLoadDone = () => useSelector(isInitialLoadDone);
export const initialLoadProgress = () => useSelector(getInitialLoadProgress);
